import React, { useEffect } from 'react'

import i18n from 'modules/core/lib/i18n'

import { useFormProvider } from 'modules/processes/components/ItemWizard/Providers/form'
import { DataCollectionCategories } from 'modules/processes/domain'
import { TaskConfigurationTypes } from 'modules/processes/lib/taskConfigurationTypes'

import Form from '../../../../components/Form'
import Assignees from '../../../../components/Form/Items/Assignees'
import Attachments from '../../../../components/Form/Items/Attachment'
import Deadline from '../../../../components/Form/Items/Deadline'
import Description from '../../../../components/Form/Items/Description'
import Mandatory from '../../../../components/Form/Items/Mandatory'
import Title from '../../../../components/Form/Items/Title'
import UploadCertificate from './Form/UploadCertificate'

const DEFAULT_DATA = () => ({
  title: i18n.t(
    'processes.process_settings.wizard.tasks.types.request_bank_account.form.defaults.title',
    {
      emoji: '\u{1F3E6}',
    }
  ),
  description: `${i18n.t(
    'processes.process_settings.wizard.tasks.types.request_bank_account.form.defaults.descriptions.1'
  )}<p><span>${i18n.t(
    'processes.process_settings.wizard.tasks.types.request_bank_account.form.defaults.descriptions.2',
    {
      double_check: `<b>${i18n.t(
        'processes.process_settings.wizard.tasks.types.request_bank_account.form.defaults.descriptions.keys.ensure'
      )}</b>`,
      emoji: '\u{1F3E6}',
    }
  )}`,
})

const Content = () => {
  const { associatedTaskItem: item, form, initializeForm } = useFormProvider()
  const defaultData = DEFAULT_DATA()

  useEffect(() => {
    initializeForm(DataCollectionCategories.bankInformation, {
      task_type: TaskConfigurationTypes.DataCollection,
      task_type_configuration: {
        configuration_fields: [
          {
            resource: 'employee',
            categories: [{ category: DataCollectionCategories.bankInformation }],
          },
        ],
      },
      title: item ? item.title : defaultData.title,
      instruction: item ? item.instruction : defaultData.description,
    })
  }, [])

  if (!form) return null

  return (
    <Form
      items={{
        title: <Title />,
        assignees: <Assignees onlyForAffectedUser readonly />,
        description: <Description />,
        uploadId: <UploadCertificate />,
        deadline: <Deadline />,
        attachments: <Attachments />,
        mandatory: <Mandatory />,
      }}
    />
  )
}

export default Content
